import "./_engagement.scss";

import {useContext, useEffect, useState} from "react";
import {
  FieldValues,
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
} from "react-hook-form";

import iconTrash from "@/assets/massification/iconTrash.svg";
import Button from "@/components/Button/Button";
import SelectCustom from "@/components/SelectCustom/SelectCustom";
import {HookFormContext} from "@/context/HookFormContext";
import {findDataArticle} from "@/function/findDataArticle";
import {Option} from "@/ts/interface/detailOffre";
import {Article} from "@/ts/interface/detailOffre";
import {OptionNameValue} from "@/ts/interface/formulaire";

// currentEngagement contient tout les engagements en cours
// engagement contient l'engagement actuellement utilisé.
function ArticleSelect({
  options,
  offreArticles,
  articleIndex,
  indexEngagement,
  nameHookForm,
  removeArticle,
  updateArticle,
  selectedArticle,
}: {
  options: Option[];
  offreArticles: Article[];
  articleIndex: number;
  indexEngagement: number;
  nameHookForm: string;
  removeArticle: UseFieldArrayRemove;
  updateArticle: UseFieldArrayUpdate<FieldValues, string>;
  selectedArticle: {article_id: number; quantite: number}[];
}): JSX.Element {
  const context = useContext(HookFormContext);

  if (!context) {
    throw new Error("HookFormContext is not provided.");
  }

  const {register, watch, getValues, setValue} = context;

  const findIndexArticle = (id: string | null): number => {
    return id
      ? offreArticles?.findIndex(
          offreArticles =>
            offreArticles.article_id.toString() === id.toString(),
        )
      : -1;
  };

  const handleWheel = (event: React.WheelEvent<HTMLInputElement>): void => {
    console.log("test");
    (event.target as HTMLInputElement).blur();
    event.preventDefault(); // Empêche l'incrémentation ou la décrémentation avec la molette
  };

  const currentArticleId = watch(`${nameHookForm}.article_id`) || null;
  const [currentArticle, setCurrentArticle] = useState<Article | undefined>(
    offreArticles[findIndexArticle(currentArticleId.toString())],
  );
  const [articleOptions, setArticleOption] = useState<Option[]>(
    currentArticleId && options
      ? findDataArticle(options, currentArticleId)
      : [],
  );
  const [optionFound, setOptionFound] = useState<Option | undefined>(
    articleOptions.length > 0 ? articleOptions?.[0] : undefined,
  );
  useEffect(() => {
    setCurrentArticle(
      offreArticles[findIndexArticle(currentArticleId.toString())],
    );
    const newArticleOption =
      currentArticleId && options
        ? findDataArticle(options, currentArticleId)
        : [];
    setArticleOption(newArticleOption);
    setOptionFound(
      newArticleOption.length > 0 ? newArticleOption?.[0] : undefined,
    );
    console.log(currentArticle);
  }, [currentArticleId]);

  const handleSubstractQuantity = (): void => {
    const currentValue = getValues(`${nameHookForm}.quantite`);
    const newValue = currentValue - (optionFound?.unite || 0);
    setValue(
      `${nameHookForm}.quantite`,
      newValue < (optionFound?.minimum || 1) ? optionFound?.minimum : newValue,
    );
  };
  const handleAddQuantity = (): void => {
    const maxQuant = maximumQuantite();
    const currentValue = getValues(`${nameHookForm}.quantite`);
    const newValue = currentValue + (optionFound?.unite || 0);
    updateArticle(articleIndex, {
      ...selectedArticle[articleIndex],
      quantite: newValue > (maxQuant || 99999999999) ? maxQuant : newValue,
    });
    setValue(
      `${nameHookForm}.quantite`,
      newValue > (maxQuant || 99999999999) ? maxQuant : newValue,
    );
  };

  // retourne le maximum commandable en fonction du maximum et des engagements en cours
  const maximumQuantite = (): number | undefined => {
    const nb_unite = currentArticle?.engagement_total_unites;
    let currentQuantite: number = 0;
    const maximum = currentArticle?.maximum;
    const currentEngagements = getValues(".engagements");
    currentEngagements.forEach((engagement: any, index: number) => {
      if (index !== indexEngagement) {
        engagement.articles.forEach(
          (article: {article_id: number; quantite: number}) => {
            if (article.article_id === currentArticle?.article_id) {
              currentQuantite = currentQuantite + article.quantite;
            }
          },
        );
      }
    });
    return nb_unite && maximum
      ? maximum - currentQuantite - nb_unite
      : undefined;
  };

  const optionsForSelect: OptionNameValue[] = offreArticles
    .filter(article => {
      return !selectedArticle.some(
        articleSelect => articleSelect.article_id === article.article_id,
      );
    })
    .map(article => {
      return {libelle: article.nom || "", value: article.article_id};
    });

  const handleDeleteArticle = (index: number): void => {
    removeArticle(index);
  };

  return (
    <div className="engagement-quantite">
      <div className="engagement-quantite--article">
        <label>Selectionnez l'article : </label>
        <SelectCustom
          defaultValue={currentArticle?.nom || ""}
          options={optionsForSelect}
          handleSelect={(value: number) => {
            updateArticle(articleIndex, {
              article_id: value,
              quantite: optionFound?.minimum,
            });
          }}
          name={`${nameHookForm}.article_id`}
        />
      </div>

      <div className="engagement-quantite--select">
        <div className="engagement-quantite--input">
          <button
            onClick={() => handleSubstractQuantity()}
            id="substract"
            type="button">
            -
          </button>
          <input
            type="number"
            id={`${nameHookForm}.quantite`}
            required={true}
            min={optionFound?.minimum}
            step={optionFound?.unite}
            max={maximumQuantite()}
            onWheel={handleWheel} // Empêcher la molette de la souris
            onWheelCapture={handleWheel}
            {...register(`${nameHookForm}.quantite`, {valueAsNumber: true})}
          />
          <button onClick={() => handleAddQuantity()} type="button" id="add">
            +
          </button>
          {selectedArticle.length > 1 ? (
            <Button
              icon={iconTrash}
              variant="secondary circle"
              label=""
              onClick={() => {
                handleDeleteArticle(articleIndex);
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ArticleSelect;
